import React, { useEffect, useState } from 'react'
import { PartnerSelect } from '../'
import { useDispatch, useSelector } from 'react-redux'
import { fetchOrganizations } from '../../features/organizations/slice'
import debounce from 'lodash.debounce'
import { PartnerNav } from './partner-nav'
// import { PartnerView } from './partner-view'
import { StatusHandler } from '../status-handler'
import { addToHolder } from '../../features/program-form/slice'

const PartnerInternal = ({
  form,
  updateForm,
  setActivePartnerForm,
  onAdd,
  onRemove,
  excludes = []
}) => {
  const dispatch = useDispatch();
  const myId = useSelector((state) => state.account.profile.id);
  const organizations = useSelector((state) => state.organizations.data);
  const status = useSelector((state) => state.organizations.status);
  const error = useSelector((state) => state.organizations.error);
  const [data, setData] = useState([]);
  const [selectValue, setSelectValue] = useState(null);
  const { partners, partners_external } = form;

  // Get all partners that already included
  const partnersIds = [...partners.map((p) => p.id), ...excludes, myId];

  // Hide selected partner from options
  const excluded = organizations.filter((o) => !partnersIds.includes(o.id));
  const options = excluded.map((o) => {
    return {
      label: o.name,
      value: o.id,
    };
  });

  const handleInput = debounce((e) => {
    if (e.target && e.target !== null) {
      const key = e.target.name;
      const value = e.target.value;
      dispatch(updateForm({ key, value }));
    }
  }, 250);

  const addItem = (item, { action }) => {
    if (onAdd && typeof onAdd === "function") {
      onAdd(item, action);
    } else {
      if (action === "select-option") {
        dispatch(
          addToHolder({ entity: "partner", type: "create", id: item.value })
        );

        addToProgramFormReduxState();

        function addToProgramFormReduxState() {
          /* !!! For rendering purpose */
          const localData = organizations.find((o) => o.id === item.value);
          // Add more field for rendering purpose
          const itemExtend = {
            ...item,
            id: item.value,
            name: item.label,
            ...localData,
          };
          const newData = [...data, itemExtend];
          setData(newData);
          handleInput({
            target: {
              name: "partners",
              value: newData,
            },
          });
          // onChange(newData)
          setSelectValue(null);
        }
      }
    }
  };

  const removeItem = (id) => {
    if (onRemove && typeof onRemove === "function") {
      onRemove(id);
    } else {
      const newData = data.filter((item) => {
        return item.value !== id;
      });
      setData(newData);
      handleInput({
        target: {
          name: "partners",
          value: newData,
        },
      });
      // onChange(newData)
    }
  };

  //eslint-disable-next-line
  const removeItemExternal = (id) => {
    const newData = partners_external.filter((item) => {
      return item.id !== id;
    });
    handleInput({
      target: {
        name: "partners_external",
        value: newData,
      },
    });
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchOrganizations());
    }
  }, [status, dispatch]);

  useEffect(() => {
    if (partners && partners.length > 0) {
      // adapter
      let result = partners.map((p) => {
        return {
          ...p,
          value: p.id || p.value,
          label: p.name || p.label,
        };
      });
      setData(result);
    }
  }, [partners]);

  return (
    <>
      <StatusHandler
        status={status}
        error={error}
        onRetry={() => dispatch(fetchOrganizations())}
      >
        <PartnerSelect
          options={options}
          data={data}
          selectValue={selectValue}
          addItem={addItem}
          removeItem={removeItem}
        />
      </StatusHandler>

      <hr className="my-5 lg:my-8" />

      <div className="mb-5 lg:mb-10">
        <PartnerNav
          onClick={() => dispatch(setActivePartnerForm("external"))}
        />
      </div>
    </>
  );
};

export default PartnerInternal
